import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import _, { isEmpty, get, cloneDeep } from 'lodash';
import { Button, message, Steps, theme } from 'antd';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Collapse,
  Popover,
  MenuItem,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import adwords from '../../../../../../../assets/images/platformWhiteBgIcons/1x-Icons/adwardsLogoWhiteBg.png';
import meta from '../../../../../../../assets/images/platformWhiteBgIcons/1x-Icons/metaLogoWhiteBg.png';
import dv360 from '../../../../../../../assets/images/platformWhiteBgIcons/1x-Icons/dv360LogoWhiteBg.png';
import tiktok from '../../../../../../../assets/images/platformWhiteBgIcons/1x-Icons/tiktokLogoWhiteBg.png';
import ion from '../../../../../../../assets/images/platformWhiteBgIcons/1x-Icons/ionLogoWhiteBg.png';
import viLogo from '../../../../../../../assets/images/platformWhiteBgIcons/1x-Icons/vodafone.png';
// import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
// import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { options } from './constant';
import { withRouter, Link } from 'react-router-dom';
import Strategy from '../../Strategy';
import { CampaignNameDataAction, getCampaignListAction, postFinalStrategyAction } from '../../../../../../../actions';
import { strategyCreativeDataAction } from '../../../../../../../actions/creative';
import { strategyListReduxAction } from '../../../../../../../actions/strategyDetails';
import { isApiCallSuccess } from '../../../../../../../selectors';

const CustomStrategy = ({ row, numColumns, headerColumns, onEdit, onCopy, platform, data }) => {

  const dispatch = useDispatch();

  console.log("row", row, platform);
  // console.log("headerColumns",headerColumns)
  const classes = useStyles();
  const [expandedRow, setExpandedRow] = useState(null);
  const [expandedRows, setExpandedRows] = useState([]);
  const [isAddComponentVisible, setComponentVisibility] = useState(false);
  const [screenType, setScreenType] = useState('');
  const [rowData, setRowData] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);

  const dataArray = Object.values(data).flat();

  const handleRowClick = (row) => {
    if (expandedRows.includes(row)) {
      setExpandedRows((prevRows) => prevRows.filter((r) => r !== row));
    } else {
      setExpandedRows((prevRows) => [...prevRows, row]);
    }
  };

  const handleEdit = (item) => {
    console.log('Edit:', item);
    setRowData(item);
    setScreenType("edit");
    setComponentVisibility((prevVisibility) => !prevVisibility);
  };

  const handleCopy = (item) => {
    console.log('Copy:', item);
    setRowData(item);
    setScreenType("copy");
    setComponentVisibility((prevVisibility) => !prevVisibility);

  };

  const handleAdd = (item) => {
    console.log('Add:', item);
    setRowData(item);
    setScreenType("add");
    setComponentVisibility((prevVisibility) => !prevVisibility);

  };

  const handleChangeStatus = (item, status) => {
    // Handle change status action for normal and expanded rows
    try {
      console.log('Change Status:', item, status);
      let clonedTableData = cloneDeep(data);

      Object.keys(clonedTableData).forEach((key) => {
        clonedTableData[key] = clonedTableData[key].map(tableData => {
          if (tableData.id === item.id) {
            tableData.stratgies.map((dataStart, stratIndex) => {
              if (dataStart.id == tableData.strategyIdToSetStatus) {
                tableData.stratgies[stratIndex].status = tableData.stratgies[stratIndex].status == 1 ? 0 : 1
              }
            })
          }
          return tableData;
        });
      });
      dispatch(strategyListReduxAction({
        strategyData: clonedTableData
      }));
      message.success('Status updated successfully')
      setAnchorEl(null);
    }
    catch (err) {
      console.log(err);
    }
  };

  const handleStatusClick = (event, rowData, strategyId, stratIndex) => {
    setAnchorEl(event.currentTarget);
    rowData["strategyIdToSetStatus"] = strategyId;
    rowData["strategyIndexToSet"] = stratIndex;
    setExpandedRow(rowData); // Update the expandedRow state with the specific row data
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  //Add campaign Id in strategies
  row.stratgies.forEach((strategy) => {
    strategy.campaignId = row.id;
  });

  return (
    <>
      <TableRow style={{ width: '100%', display: "none" }}>
        {headerColumns.map((column) => (
          <TableCell key={column.id}>{column.label}</TableCell>
        ))}
        <TableCell key="actions">Actions</TableCell>
      </TableRow>
      {row.stratgies &&
        row.stratgies.map((strategy, stratIndex) => (
          <TableRow key={strategy.id} style={{ width: '100%' }}>
            {headerColumns.map((column) => (

              <TableCell key={column.id}
                style={{
                  border: '1px solid #ddd',
                  padding: '8px',
                }}
              >
                {column.component ? column.component(strategy) : strategy[column.name]}
                {column.name === 'status' && (
                  <IconButton
                    size="small"
                    onClick={(e) => handleStatusClick(e, row, strategy.id, stratIndex)}
                  >
                    <i className="ti ti-chevron-down"></i>
                  </IconButton>
                )}
                {/* {console.log("column",strategy[column.name])} */}
              </TableCell>
            ))}
            <TableCell key="actions">
              <IconButton onClick={() => onEdit(strategy, platform)}>
                {/* <IconButton onClick={() => { }}> */}
                <i className="ti ti-pencil"></i>
              </IconButton>
              {/* <IconButton onClick={() => onCopy(strategy)}>
                <i className="ti ti-files"></i>
              </IconButton> */}
            </TableCell>
            {
              expandedRow && expandedRow.stratgies
              && expandedRow.stratgies[expandedRow.strategyIndexToSet] &&
              expandedRow.stratgies[expandedRow.strategyIndexToSet].hasOwnProperty("status") &&
              expandedRow.stratgies[expandedRow.strategyIndexToSet].status != 2 &&
              <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                style={{ boxShadow: "none" }}
              >
                <div className={classes['status-popover']}>
                  {
                    expandedRow && expandedRow.stratgies && expandedRow.stratgies[expandedRow.strategyIndexToSet].status == 1 &&
                    <MenuItem onClick={() => handleChangeStatus(row, 'Inactive')}>
                      Inactive
                    </MenuItem>
                  }
                  {
                    expandedRow && expandedRow.stratgies && expandedRow.stratgies[expandedRow.strategyIndexToSet].status == 0 &&
                    <MenuItem onClick={() => handleChangeStatus(row, 'Inactive')}>
                      Active
                    </MenuItem>
                  }
                </div>
              </Popover>
            }
          </TableRow>
        ))}
    </>
  );
};

const useStyles = makeStyles({
  customTable: {
    '& .MuiTableRow-root': {
      padding: '2px 8px!important',
    },
    '& .MuiTableCell-sizeSmall': {
      padding: '5px 8px!important',
      fontFamily: "Poppins",
      color: "#040B1B"
    },
    '& .MuiTableCell-head': {
      fontWeight: 700,
      padding: "10px !important"
    },
    '& .MuiIconButton-label': {
      color: "#303890"
    },
    '& .status-column': {
      position: 'relative',
    },
    '& .status-popover': {
      padding: '8px',
    },
    '& .rounded-table': {
      borderRadius: '10px', // Adjust this value for the desired border-radius
      overflow: 'hidden', // To ensure the border-radius is applied correctly
    },
  },
  tableContainer: {
    border: "0.5px solid #C4CCD8",
    borderRadius: '10px',
  },
  tableHeader: {
  }
});

const CampaignTable = ({ tableData, setTableData, options, setStrategy, setShowStepper, strategyNext, next, setStrategyNext }) => {
  const tenantId = useSelector(state => get(state, 'app.preSignInState.tenantId', ''));
  const userId = useSelector(state => get(state, 'app.preSignInData.userId', ''));
  const authToken = useSelector(state => get(state, 'app.signInData.authToken', ''));
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("next", strategyNext)
    if (strategyNext)
      tableFinalPayload(tableData);
  }, [strategyNext])

  const tableFinalPayload = async (tableData) => {

    try {

      let resultPayload = {};
      console.log(tableData, 'TABLE DATA &&&');

      let errorCountForMeta = 0;
      let errorCountForMetaBidStrategy = 0;
      let errorCountForDv360 = 0;
      let errorCountForAdwords = 0;


      if (tableData.ads && tableData.ads.length > 0) {
        tableData.ads.forEach((adsItem) => {
          adsItem.stratgies.forEach((strategy) => {
            if (!strategy.bidStrategy || strategy.bidStrategy === '0') {
              // Show message for empty or '0' bidStrategy
              console.log('Message: Bid strategy is empty or 0 for ads:', adsItem.name);
              errorCountForAdwords++
            }
            else{
              return;
            }
          });
        });
        if (errorCountForAdwords != 0) {
          setStrategyNext(0)
          message.error('Please fill BidStrategy for Adwords:');
          return;
        }
      }

      if (tableData.meta && tableData.meta.length > 0) {
        tableData.meta.forEach((dataMet) => {
          if (dataMet.stratgies && dataMet.stratgies.length > 0) {
            dataMet.stratgies.forEach((dataStart) => {
              if (dataStart.targeting) {
                if (dataStart.targeting.pageId && dataStart.targeting.pageId.toString().length > 0) {
                  return;
                }
                else {
                  errorCountForMeta++;
                }
                if (dataStart.targeting.location && dataStart.targeting.location.length > 0) {
                  return;
                }
                else {
                  errorCountForMeta++
                }
              }
            })
          }
        })
        if (errorCountForMeta != 0) {
          setStrategyNext(0)
          message.error("Please fill location and page for meta");
          return;
        }
      }


      if (tableData.meta && tableData.meta.length > 0) {
        tableData.meta.forEach((metaItem) => {
          metaItem.stratgies.forEach((strategy) => {
            if (!strategy.bidStrategy || strategy.bidStrategy === '0') {
              // Show message for empty or '0' bidStrategy
              console.log('Message: Bid strategy is empty or 0 for meta:', metaItem.name);
              errorCountForMetaBidStrategy++
            }
            else{
              return;
            }
          });
        });
        if (errorCountForMetaBidStrategy != 0) {
          setStrategyNext(0)
          message.error('Please fill BidStrategy for Meta');
          return;
        }
      }

      if (tableData.dv360 && tableData.dv360.length > 0) {
        tableData.dv360.forEach((dv360Item) => {
          dv360Item.stratgies.forEach((strategy) => {
            if (!strategy.bidStrategy || strategy.bidStrategy === '0') {
              // Show message for empty or '0' bidStrategy
              console.log('Message: Bid strategy is empty or 0 for dv360:', dv360Item.name);
              errorCountForDv360++
            }
            else{
              return;
            }
          });
        });
        if (errorCountForDv360 != 0) {
          setStrategyNext(0)
          message.error('Please fill BidStrategy for DV360:');
          return;
        }
      }
      


      if (tableData) {
        Object.keys(tableData).forEach((platform, index) => {
          let strategyName = `${platform}Strategy`;
          resultPayload[strategyName] = {};
          tableData[platform].forEach((item, i) => {
            let id = item.id.toString();
            console.log("id----", id)

            // Map the stratgies array and update startDate and endDate to sDate and eDate
            item.stratgies = item.stratgies.map((strat) => {
              if (!strat.hasOwnProperty('sDate') || !strat.hasOwnProperty('eDate')) {
                return {
                  ...strat,
                  sDate: strat.startDate,
                  eDate: strat.endDate,
                };
              } else {
                return strat;
              }
            });
            resultPayload[strategyName][id] = item.stratgies.map(strat => strat.id);
            console.log("resultPayload", resultPayload);
            console.log("id----", id)
            resultPayload[platform] = tableData[platform].map(val => val.stratgies); // stratgies spelling wrong at backend
            resultPayload[platform] = resultPayload[platform].flat();
            // resultPayload[platform] = resultPayload[platform].map(data => ({ ...data }));
          });
        });
        console.log("resultPayload", resultPayload);
        // return resultPayload;

      }

      await dispatch(postFinalStrategyAction({ tenantId, authToken, userId, payload: resultPayload })).then((data) => {
        const {
          responseCode: { status = "", msg },
          responseObj = {},
        } = data;
        console.log("data", data)

        if (status === "Success") {
          // setBasicDetalsSubmit(response);
          // setCampaignId(responseObj);
          // localStorage.setItem('campaignIdCreated', JSON.stringify(responseObj));
          console.log(responseObj, '^^^^^^^^^^^^^^^^^^^^^^^66');
          dispatch(strategyCreativeDataAction({ data: responseObj }))
          message.success(msg)
          next();
        }
        else if (status == "Fail") {
          setStrategyNext(0)
          message.error(msg)
        }
        else {
          console.log("Data not found");
        }
      })
        .catch((error) => {
          setStrategyNext(0)
          console.error(error);
        });
    }
    catch (err) {
      setStrategyNext(0)
    }
  };

  let payload = {
    "ads": {
      "campaignName": []
    },
    "facebook": {
      "campaignName": []
    },
    "dv360": {
      "campaignName": []
    },
    "tiktok": {
      "campaignName": []
    },
    "ion": {
      "campaignName": []
    }
  };

  // Iterate through the table data and populate the payload
  Object.keys(tableData).forEach(platform => {
    tableData[platform].forEach(campaign => {
      if (!payload[platform]) {
        payload[platform] = { "campaignName": [] };
      }
      payload[platform]["campaignName"].push(campaign.name);

      // Check for duplicates between "meta" and "facebook"
      if (platform === "meta" && payload["facebook"]) {
        payload["facebook"]["campaignName"].push(campaign.name);
      }

      if (platform === "facebook" && payload["meta"]) {
        payload["meta"]["campaignName"].push(campaign.name);
      }
    });
  });

  // console.log(payload);
  // localStorage.setItem("campaignNamePayload", JSON.stringify(payload));
  // dispatch(CampaignNameDataAction({data:payload}))

  const classes = useStyles();
  const [expandedRow, setExpandedRow] = useState(null);
  const [expandedRows, setExpandedRows] = useState([]);
  const [isAddComponentVisible, setComponentVisibility] = useState(false);
  const [screenType, setScreenType] = useState('');
  const [rowData, setRowData] = useState(null);
  const [platformType, setPlatformType] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  // const dataArray = Object.values(tableData).flat();
  const platformImages = {
    ads: adwords,
    meta: meta,
    dv360: dv360,
    tiktok: tiktok,
    ion: ion,
    viads:viLogo
    // Add more platforms as needed
  };
  const handleRowClick = (row) => {
    if (expandedRows.includes(row)) {
      setExpandedRows((prevRows) => prevRows.filter((r) => r !== row));
    } else {
      setExpandedRows((prevRows) => [...prevRows, row]);
    }
  };

  const handleEdit = (item, platform) => {
    console.log('Edit:', item);
    setRowData(item);
    setPlatformType(platform);
    setScreenType("edit");
    setComponentVisibility((prevVisibility) => !prevVisibility);
  };

  const handleCopy = (item, platform) => {
    console.log('Copy:', item);
    setRowData(item);
    setPlatformType(platform);
    setScreenType("copy");
    setComponentVisibility((prevVisibility) => !prevVisibility);

  };

  const handleAdd = (item, platform) => {
    console.log('Add:', item);
    setRowData(item);
    setPlatformType(platform);
    setScreenType("add");
    setComponentVisibility((prevVisibility) => !prevVisibility);

  };

  const handleChangeStatus = (item, status) => {
    // Handle change status action for normal and expanded rows
    try {
      console.log('Change Status:', item, status, tableData);

      let clonedTableData = cloneDeep(tableData);

      Object.keys(clonedTableData).forEach((key) => {
        clonedTableData[key] = clonedTableData[key].map(tableData => {
          if (tableData.id === item.id) {
            tableData.status = item.status === 1 ? 0 : 1;
          }
          return tableData;
        });
      });
      dispatch(strategyListReduxAction({
        strategyData: clonedTableData
      }));
      console.log(clonedTableData, 'Change Status');
      message.success('Status updated successfully')
      setAnchorEl(null);
    }
    catch (err) {
      console.log(err)
    }
  };

  const handleStatusClick = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setExpandedRow(rowData); // Update the expandedRow state with the specific row data
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const currency = JSON.parse(localStorage.getItem('currency'));

  return (
    <>
      {!isAddComponentVisible &&
        <TableContainer component={Paper} elevation={0} className={classes.tableContainer}>
          <Table classes={{ root: classes.customTable }} size="small">
            <TableHead className={classes.tableHeader} >
              <TableRow>
                {options.columns.map((column) => (
                  <TableCell key={column.id}
                    style={{
                      border: '1px solid #ddd',
                      padding: '8px',
                      background: '#fff',
                      // Optional: Add background color to header
                    }}
                  >
                    {column.name === 'budget' && currency && currency.value ? (
                      <>
                        {column.label} ({currency.value})
                      </>
                    ) : (
                      column.label
                    )}
                  </TableCell>
                ))}
                <TableCell key="actions" style={{ border: '1px solid #ddd', padding: '8px' }}>
                  ACTIONS
                </TableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              {Object.entries(tableData || []).map(([platform, platformData]) => (
                <React.Fragment key={platform}>
                  {platformData.map((row, index) => (
                    <React.Fragment key={row.id}>
                      <TableRow style={{ background: "#EBF1FA" }} >
                        {options.columns.map((column) => (
                          <TableCell key={column.id}
                            className={column.name === 'status' ? 'status-column' : ''}
                            style={{
                              border: '1px solid #ddd',
                              padding: '8px',
                            }}
                          >
                            {column.id === 1 && column.label === 'PLATFORM' && index === 0 ? (
                              <span>
                                {platform && platformImages[platform.toLowerCase()] ? (
                                  <img
                                    src={platformImages[platform.toLowerCase()]}
                                    alt={platform}
                                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                                  />
                                ) : (
                                  platform
                                )}
                              </span>
                            ) : null}

                            {column.component ? column.component(row) : row[column.name]}
                            {column.name === 'name' && (
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRowClick(row);
                                }}
                              >
                                {expandedRows.includes(row) ? (
                                  <i className='ti ti-chevron-up'></i>
                                ) : (
                                  <i className='ti ti-chevron-down'></i>
                                )}
                              </IconButton>
                            )}
                            {column.name === 'status' && (
                              <IconButton
                                size="small"
                                onClick={(e) => handleStatusClick(e, row)}
                              >
                                <i className="ti ti-chevron-down"></i>
                              </IconButton>
                            )}
                            {/* {column.component ? column.component(row) : row[column.name]} */}
                          </TableCell>
                        ))}
                        <TableCell key="actions" style={{ border: '1px solid #ddd', padding: '8px', background: "#EBF1FA" }}>
                          {/* <IconButton onClick={() => handleEdit(row)}> */}
                          {/* <IconButton onClick={() => { }}>
                            <i className="ti ti-pencil"></i>
                          </IconButton> */}
                          <IconButton onClick={() => handleAdd(row, platform)}>
                            <i className="ti ti-circle-plus"></i>
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      {/* {expandedRow === row && <CustomStrategy row={row} numColumns={options.columns.length} />} */}
                      {/* {expandedRow === row && (
                    <CustomStrategy
                      row={row}
                      numColumns={options.columns.length}
                      headerColumns={options.columns}
                      onEdit={handleEdit}
                      onCopy={handleCopy}
                    />
                  )} */}
                      {expandedRows.includes(row) && (
                        <CustomStrategy
                          row={row}
                          platform={platform}
                          numColumns={options.columns.length}
                          headerColumns={options.columns}
                          onEdit={handleEdit}
                          onCopy={handleCopy}
                          data={tableData}
                        />
                      )}

                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
          {
            expandedRow && expandedRow.hasOwnProperty("status") && expandedRow.status != 2 &&
            <Popover
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <div className={classes['status-popover']}>
                {
                  expandedRow && expandedRow.status == 1 &&
                  <MenuItem onClick={() => handleChangeStatus(expandedRow, 'Inactive')}>
                    Inactive
                  </MenuItem>
                }
                {
                  expandedRow && expandedRow.status == 0 &&
                  <MenuItem onClick={() => handleChangeStatus(expandedRow, 'Inactive')}>
                    Active
                  </MenuItem>
                }
              </div>
            </Popover>
          }

        </TableContainer>
      }
      {isAddComponentVisible &&
        <Strategy
          rowData={rowData}
          platformType={platformType}
          setStrategy={setStrategy}
          setShowStepper={setShowStepper}
          setComponentVisibility={setComponentVisibility}
          screenType={screenType}
          tableData={tableData}
          setTableData={setTableData}
        />
      }
    </>
  );
};

export const MyTableComponent = (props) => {
  // const strategyListData = localStorage.getItem('strategyListData');
  const strategyData = useSelector(state => get(state, 'app.strategyData', ''));
  console.log("mytable strategyData", strategyData)
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    // Update tableData when strategyData changes
    setTableData(strategyData);
  }, [strategyData]);

  console.log("mytable tableData", tableData);


  const tenantId = useSelector(state => get(state, 'app.preSignInState.tenantId', ''));
  const userId = useSelector(state => get(state, 'app.preSignInData.userId', ''));
  const authToken = useSelector(state => get(state, 'app.signInData.authToken', ''));
  const dispatch = useDispatch();

  // useEffect(() => {
  //   const { match: { params: { id } } } = props;
  //   if (id) {
  //     getStrategyData(id);
  //   }
  // }, []);

  const getStrategyData = async (id) => {
    console.log("i am here")
    let params = { strategy: 'list', campaignId: id };
    await dispatch(getCampaignListAction({ tenantId, authToken, userId, params })).then((data) => {
      // console.log("data", data)
      const {
        responseCode: { status = "" },
        responseObj,
      } = data;

      if (isApiCallSuccess(status)) {
        // Call the function with your response data
        setTableData(responseObj);
        console.log(responseObj, 'RESPONSE OBJ');

        dispatch(strategyListReduxAction({
          strategyData: responseObj
        }));
      } else {
        console.log("Campaign List by Id Api failed!");
      }
    }).catch((error) => {
      console.error(error);
    });
  }

  console.log(tableData, '*** TABLE DATA ***');

  return <CampaignTable next={props.next} strategyNext={props.strategyNext} tableData={tableData} setTableData={setTableData} options={options} setStrategy={props.setStrategy} setShowStepper={props.setShowStepper} setStrategyNext={props.setStrategyNext} />;

  // const strData = props.strategyData && props.strategyData.length > 0 ? props.strategyData : JSON.parse(strategyListData);
  // return <CampaignTable tableData={tableData} setTableData={setTableData} options={options} setStrategy={props.setStrategy} setShowStepper={props.setShowStepper} />;
};
export default withRouter(MyTableComponent);